import * as React from 'react';
import { Input } from 'antd';
import * as classnames from 'classnames';

import './Input.less';

interface Props {
  size?: 'default' | 'small' | 'large';
  type?: string;
  className?: string;
  name?: string;
  value?: string;
  onChange?: (name: string, value: string) => void;
  addonBefore?: string | React.ReactNode;
  prefix?: string | React.ReactNode;
  round?: boolean;
  placeholder?: string;
}

class InputWrapper extends React.PureComponent<Props> {
  static defaultProps = {
    type: 'text',
    className: '',
    name: '',
    size: 'default',
    round: false,
    prefix: '',
    placeholder: '',
    onChange: () => null,
    value: '',
  };
  static TextArea = Input.TextArea;

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { onChange } = this.props;
    if (onChange) {
      const { value, name } = e.target as HTMLInputElement;
      onChange(name, value);
    }
  };

  render() {
    const {
      type,
      className,
      value,
      size,
      name,
      round,
      prefix,
      placeholder,
      addonBefore,
    } = this.props;
    const clsName = classnames('bc-input', className, {
      'bc-input-round': round,
    });
    return (
      <Input
        type={type}
        className={clsName}
        value={value}
        size={size}
        name={name}
        prefix={prefix}
        placeholder={placeholder}
        onChange={this.handleChange}
        addonBefore={addonBefore}
      />
    );
  }
}

export default InputWrapper;



// WEBPACK FOOTER //
// ./src/components/Input/Input.tsx